import React from 'react';
import {connect} from 'react-redux';
import OptimizeButton from 'components/molecules/optimize-button';
import {Dashboard as BaseDashboard} from 'components/organisms/used-players-list/components/dashboard';

class Dashboard extends BaseDashboard {
    render() {
        const {sportConfig} = this.props;
        const lineupsQuantity = this.getLineupsQuantity();
        const usedPlayersQuantity = this.getUsedPlayersQuantity();

        if (sportConfig.isModeLateswap()) {
            const totalPlayersQuantity = this.getTotalPlayersQuantity();

            return (
                <div className="players-heading">
                    <strong>{totalPlayersQuantity}</strong> Total Players |<strong>{usedPlayersQuantity}</strong>{' '}
                    Players Used |<strong>{lineupsQuantity}</strong> Lineups
                    <OptimizeButton />
                </div>
            );
        }

        return (
            <div className="players-heading">
                <strong>{usedPlayersQuantity}</strong> Players Used |<strong>{lineupsQuantity}</strong> Lineups
                <OptimizeButton />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {usedPlayers, lineupsData, filterLineupsByPlayer, sportConfig} = state;

    return {
        usedPlayers: usedPlayers.players,
        lineups: lineupsData.lineups,
        filterLineupsByPlayer,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(Dashboard);
